import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    brands: [
      {
        id: 4,
        name: 'Audi',
        url: 'audi',
        logo: require('./assets/images/audi.svg'),
        baner: require('./assets/images/baner-audi.png')
      },
      {
        id: 5,
        name: 'Audi Select:plus',
        url: 'audi_select_plus',
        logo: require('./assets/images/audi-select-plus.png'),
        baner: require('./assets/images/baner-audi-select-plus.png')
      },
      {
        id: 3,
        name: 'Das WeltAuto',
        url: 'das_weltauto',
        logo: require('./assets/images/dwa_new.svg'),
        baner: require('./assets/images/baner-das-weltauto.png')
      },
      {
        id: 7,
        name: 'Porsche',
        url: 'porsche',
        logo: require('./assets/images/porsche_2023.svg'),
        baner: require('./assets/images/baner-porsche.png')
      },
      {
        id: 8,
        name: 'Skoda',
        url: 'skoda',
        logo: require('./assets/images/skoda_logo_green.svg'),
        baner: require('./assets/images/baner-skoda.png')
      },
      {
        id: 1,
        name: 'Volkswagen',
        url: 'volkswagen',
        logo: require('./assets/images/volkswagen.png'),
        baner: require('./assets/images/baner-volkswagen.png')
      },
      {
        id: 2,
        name: 'Volkswagen Dostawcze',
        url: 'volkswagen_dostawcze',
        logo: require('./assets/images/volkswagen-dostawcze.png'),
        baner: require('./assets/images/baner-volkswagen-dostawcze.png')
      },
      {
        id: 6,
        name: 'Jazda testowa',
        url: 'jazda_testowa',
        logo: require('./assets/images/test.png'),
        baner: require('./assets/images/baner-jazdy-testowe.png')
      },
      {
        id: 9,
        name: 'Maxus',
        url: 'maxus',
        logo: require('./assets/images/maxus.svg'),
        baner: require('./assets/images/baner-maxus.jpg')
      },
      {
        id: 10,
        name: 'MG',
        url: 'MG',
        logo: require('./assets/images/MG-black-logo_1200x628.png'),
        baner: require('./assets/images/MG_GKLEAD.webp')
      },
      {
        id: 11,
        name: 'BYD',
        url: 'BYD',
        logo: require('./assets/images/BYD_grey.svg'),
        baner: require('./assets/images/byd_baner.jpg')
      }
    ],
    models: {
      9: [
        {
          id: 1,
          name: 'e-Deliver 3'
        },
        {
          id: 2,
          name: 'e-Deliver 3 podwozie'
        },
        {
          id: 3,
          name: 'e-Deliver 9'
        },
        {
          id: 4,
          name: 'e-Deliver 9 podwozie'
        },
        {
          id: 5,
          name: 'Euniq5'
        },
        {
          id: 6,
          name: 'Euniq6 SUV'
        },
        {
          id: 7,
          name: 'MIFA9'
        },
        {
          id: 8,
          name: 'T90 EV Pickup'
        },
      ],
      8: [
        {
          id: 1,
          name: 'Skoda Citigo'
        },
        {
          id: 2,
          name: 'Skoda ENYAQ'
        },
        {
          id: 3,
          name: 'Skoda ENYAQ IV'
        },
        {
          id: 4,
          name: 'Skoda Fabia'
        },
        {
          id: 5,
          name: 'Skoda Kamiq'
        },
        {
          id: 6,
          name: 'Skoda Karoq'
        },
        {
          id: 7,
          name: 'Skoda Kodiaq'
        },
        {
          id: 8,
          name: 'Skoda Octavia IV'
        },
        {
          id: 9,
          name: 'Skoda Scala'
        },
        {
          id: 10,
          name: 'Skoda Superb'
        }
      ],
      7: [
        {
          id: 1,
          name: '718'
        },
        {
          id: 2,
          name: '911'
        },
        {
          id: 3,
          name: 'Macan'
        },
        {
          id: 4,
          name: 'Cayenne'
        },
        {
          id: 5,
          name: 'Taycan'
        },
        {
          id: 6,
          name: 'Panamera'
        }
      ],
      1: [
        {
          id: 1,
          name: 'Arteon'
        },
        {
          id: 2,
          name: 'e-UP!'
        },
        {
          id: 3,
          name: 'Golf'
        },
        {
          id: 4,
          name: 'Golf Variant'
        },
        {
          id: 5,
          name: 'Golf Spotrsvan'
        },
        {
          id: 6,
          name: 'ID.3'
        },
        {
          id: 7,
          name: 'ID.4'
        },
        {
          id: 8,
          name: 'ID.5'
        },
        {
          id: 10,
          name: 'Jetta'
        },
        {
          id: 11,
          name: 'Passat Limousine'
        },
        {
          id: 12,
          name: 'Passat Variant'
        },
        {
          id: 13,
          name: 'Polo'
        },
        {
          id: 14,
          name: 'Sharan'
        },
        {
          id: 15,
          name: 'Tiguan'
        },
        {
          id: 16,
          name: 'Touareg'
        },
        {
          id: 17,
          name: 'Touareg e-hybrid'
        },
        {
          id: 18,
          name: 'Touran'
        },
        {
          id: 19,
          name: 'T-Cross'
        },
        {
          id: 20,
          name: 'T-Roc'
        },
        {
          id: 21,
          name: 'UP!'
        }
      ],
      2: [
        {
          id: 1,
          name: 'Amarok'
        },
        {
          id: 2,
          name: 'Caddy osobowy'
        },
        {
          id: 3,
          name: 'Caddy Furgon'
        },
        {
          id: 4,
          name: 'Crafter'
        },
        {
          id: 5,
          name: 'Transporter Furgon'
        },
        {
          id: 6,
          name: 'Transporter Osobowy'
        },
        {
          id: 7,
          name: 'ID.Buzz'
        },
        {
          id: 8,
          name: 'Multivan'
        }
      ],
      4: [
        {
          id: 1,
          name: 'A1'
        },
        {
          id: 2,
          name: 'A3'
        },
        {
          id: 3,
          name: 'A4'
        },
        {
          id: 4,
          name: 'A5'
        },
        {
          id: 5,
          name: 'A6'
        },
        {
          id: 6,
          name: 'A7'
        },
        {
          id: 7,
          name: 'A8'
        },
        {
          id: 8,
          name: 'Q2'
        },
        {
          id: 9,
          name: 'Q3'
        },
        {
          id: 10,
          name: 'Q4'
        },
        {
          id: 11,
          name: 'Q4 e-tron'
        },
        {
          id: 12,
          name: 'Q5'
        },
        {
          id: 13,
          name: 'Q7'
        },
        {
          id: 14,
          name: 'Q8'
        },
        {
          id: 15,
          name: 'Q8 e-tron'
        },
        {
          id: 16,
          name: 'TT'
        },
        {
          id: 17,
          name: 'R8'
        },
        {
          id: 18,
          name: 'RS e-tron GT'
        },
        {
          id: 19,
          name: 'e-tron GT'
        }
      ],
      5: [
        {
          id: 1,
          name: 'A1'
        },
        {
          id: 2,
          name: 'A3'
        },
        {
          id: 3,
          name: 'A4'
        },
        {
          id: 4,
          name: 'A5'
        },
        {
          id: 5,
          name: 'A6'
        },
        {
          id: 6,
          name: 'A7'
        },
        {
          id: 7,
          name: 'A8'
        },
        {
          id: 8,
          name: 'Q2'
        },
        {
          id: 8,
          name: 'Q3'
        },
        {
          id: 9,
          name: 'Q5'
        },
        {
          id: 10,
          name: 'Q7'
        },
        {
          id: 11,
          name: 'Q8'
        },
        {
          id: 12,
          name: 'TT'
        },
        {
          id: 13,
          name: 'R8'
        },
        {
          id: 14,
          name: 'e-tron'
        }
      ],
      10: [
        {
          id: 1,
          name: 'MG3'
        },
        {
          id: 2,
          name: 'MG4'
        },
        {
          id: 3,
          name: 'MG CYBERSTER'
        },
        {
          id: 4,
          name: 'MG ZS'
        },
        {
          id: 5,
          name: 'MG HS'
        },
        {
          id: 6,
          name: 'NOWY MG HS'
        },
        {
          id: 7,
          name: 'NOWY MG HS PLUG-IN HYBRID'
        },
        {
          id: 8,
          name: 'NOWY MG ZS HYBRID+'
        }
      ],
      11: [
        {
          id: 1,
          name: 'Seal'
        },
        {
          id: 2,
          name: 'Seal U'
        },
        {
          id: 3,
          name: 'Dolphin'
        },
        {
          id: 4,
          name: 'Seal U-DMi'
        },
        {
          id: 5,
          name: 'Sealion 7'
        }
      ]
    },
    localization: {
      1: [
        {
          id: 1,
          name: 'Volkswagen Krotoski Warszawa - ul. Radzymińska 78, Warszawa',
        },
        {
          id: 2,
          name: 'Volkswagen Krotoski Warszawa-Wolica, al. Katowicka 47, Wolica',
        },
        {
          id: 3,
          name: 'Volkswagen Krotoski Częstochowa - ul. Makuszyńskiego 74/76, Częstochowa',
        },
        {
          id: 4,
          name: 'Volkswagen Krotoski Łódź - ul. Niciarniana 51/53, Łódź',
        }
      ],
      2: [
        {
          id: 1,
          name: 'Volkswagen Krotoski Warszawa - ul. Radzymińska 78, Warszawa',
        },
        {
          id: 2,
          name: 'Volkswagen Krotoski Częstochowa - ul. Makuszyńskiego 74/76, Częstochowa',
        },
        {
          id: 3,
          name: 'Volkswagen Krotoski Łódź - ul. Niciarniana 51/53, Łódź',
        }
      ],
      3: [
        {
          id: 1,
          name: 'Łódź',
        },
        {
          id: 2,
          name: 'Nadarzyn',
        },
        {
          id: 3,
          name: 'Warszawa',
        },
        {
          id: 4,
          name: 'Częstochowa',
        }
      ],
      4: [
        {
          id: 1,
          name: 'Audi Krotoski Warszawa - ul. Radzymińska 267, Warszawa',
        },
        {
          id: 2,
          name: 'Audi Krotoski Warszawa-Wolica - al. Katowicka 43, Wolica',
        },
        {
          id: 3,
          name: 'Audi Krotoski Częstochowa - ul. Kornela Makuszyńskiego 74/76, Częstochowa',
        },
        {
          id: 4,
          name: 'Audi Centrum Łódź - al. Wł. Bartoszewskiego 13, Łódź',
        },
        {
          id: 5,
          name: 'Audi Krotoski Łódź - ul. Niciarniana 51/53, Łódź',
        }
      ],
      5: [
        {
          id: 1,
          name: 'Audi Krotoski Warszawa - ul. Radzymińska 267, Warszawa',
        },
        {
          id: 2,
          name: 'Audi Krotoski Warszawa-Wolica - al. Katowicka 43, Wolica',
        },
        {
          id: 3,
          name: 'Audi Krotoski Częstochowa - ul. Kornela Makuszyńskiego 74/76, Częstochowa',
        },
        {
          id: 4,
          name: 'Audi Centrum Łódź - al. Wł. Bartoszewskiego 13, Łódź',
        },
        {
          id: 5,
          name: 'Audi Krotoski Łódź - ul. Niciarniana 51/53, Łódź',
        }
      ],
      8: [
        {
          id: 1,
          name: 'CZĘSTOCHOWA ul. Makuszyńskiego 74/76',
        },
        {
          id: 2,
          name: 'ŁÓDŹ ul. Niciarniana 51/53',
        },
        {
          id: 3,
          name: 'NADARZYN al. Katowicka 83',
        },
        {
          id: 4,
          name: 'WARSZAWA ul. Radzymińska 78',
        }
      ],
      10: [
        {
          id: 1,
          name: 'Warszawa-Stawki',
        },
        {
          id: 2,
          name: 'Warszawa-Wawelska',
        },
        {
          id: 3,
          name: 'Poznań',
        },
        {
          id: 4,
          name: 'Łódź',
        },
        {
          id: 5,
          name: 'Wrocław',
        },
        {
          id: 6,
          name: 'Katowice',
        }
      ],
      11: [
        {
          id: 1,
          name: 'Warszawa',
        },
        {
          id: 2,
          name: 'Łódź',
        },
        {
          id: 3,
          name: 'Katowice',
        }
      ]
    },
    uniqueBrands: [
      {
        id: 8,
        name: 'Skoda'
      },
      {
        id: 7,
        name: 'Porsche'
      },
      {
        id: 1,
        name: 'Volkswagen'
      },
      {
        id: 2,
        name: 'Volkswagen dostawcze'
      },
      {
        id: 4,
        name: 'Audi'
      },
      {
        id: 10,
        name: 'MG'
      },
      {
        id: 11,
        name: 'BYD'
      }
    ],
    months: [
      {
        id: 1,
        name: 'Styczeń'
      },
      {
        id: 2,
        name: 'Luty'
      },
      {
        id: 3,
        name: 'Marzec'
      },
      {
        id: 4,
        name: 'Kwiecień'
      },
      {
        id: 5,
        name: 'Maj'
      },
      {
        id: 6,
        name: 'Czerwiec'
      },
      {
        id: 7,
        name: 'Lipiec'
      },
      {
        id: 8,
        name: 'Sierpień'
      },
      {
        id: 9,
        name: 'Wrzesień'
      },
      {
        id: 10,
        name: 'Październik'
      },
      {
        id: 11,
        name: 'Listopad'
      },
      {
        id: 12,
        name: 'Grudzień'
      }
    ],
    hours: [
      {
        id: 1,
        name: '8:00-12:00'
      },
      {
        id: 2,
        name: '12:00-16:00'
      },
      {
        id: 3,
        name: '16:00-19:00'
      }
    ],
    translations: {
      model: 'Model',
      month: 'Miesiąc',
      year: 'Rok planowanej zmiany',
      testRide: 'Zainteresowany jazdą testową',
      serviceOffer: 'Chce poznać ofertę serwisową',
      insurance: 'Chce poznać ofertę ubezpieczenia',
      prefered_brand: 'Zainteresowany marką',
      brand: 'Zainteresowany marką',
      prefered_model: 'Zainteresowany modelem',
      first_name: 'Imię',
      last_name: 'Nazwisko',
      email: 'Adres email',
      phone: 'Numer telefonu',
      localization: 'Wybrana lokalizacja',
      hour: 'Godzina do kontaktu',
      accesories: 'Zainteresowany przedstawieniem oferty oryginalnych akcesoriów',
      accept1: 'Podanie moich danych osobowych było dobrowolne i świadome.',
      accept2: ' Wyrażam zgodę na przetwarzanie w celach marketingowych produktów finansowych, w tym leasing, kredyt, ubezpieczenie bądź pozostałe.',
      accept3: 'Wyrażam zgodę na otrzymywanie drogą elektroniczną na wskazany adres poczty elektronicznej informacji marketingowych',
      accept3: 'Wyrażam zgodę na otrzymywanie drogą elektroniczną na wskazany adres poczty elektronicznej informacji handlowych',
      accept4: 'Wyrażam zgodę na wykorzystanie numeru telefonu dla celów marketingu bezpośredniego towarów i usług',
      accept5: 'Wyrażam zgodę na wykorzystanie numeru telefonu dla celów przekazywania informacji handlowej'
    },
    submitState: null
  },
  mutations: {
    setSubmitState(state, payload) { state.submitState = payload }
  },
  getters: {
    getBrands: state => state.brands,
    getBrandByUrl: state => url => state.brands.find(e => e.url == url),
    getMonths: state => state.months,
    getModelsByBrandId: state => id => state.models[id] ? state.models[id] : null,
    getLocalizationByBrandId: state => id => state.localization[id] ? state.localization[id] : null,
    getYears: state => {
      let start = new Date().getFullYear()
      let count = 10;
      var years = [];
      for (let i = start; i <= start + count; i++) {
        years.push(i)
      }
      return years;
    },
    getHours: state => state.hours,
    getSubmitState: state => state.submitState,
    getUniqueBrands: state => state.uniqueBrands,
    getModelsByBrandName: state => name => {
      if (!name) { return };
      let brandID = state.uniqueBrands.find(e => e.name == name).id;
      return state.models[brandID] ? state.models[brandID] : null;
    },
    getLocalizationByBrandName: state => name => {
      if (!name) { return };
      let brandID = state.uniqueBrands.find(e => e.name == name).id;
      return state.localization[brandID] ? state.localization[brandID] : null;
    },
  },
  actions: {
    async submit({ state, commit }, data) {
      let message = Object.keys(state.translations).map(e => {
        let value = data[e] ? data[e] : '-';
        return state.translations[e] + `: <strong>${value}</strong>`;
      }).join("<br>\t\n");

      return new Promise(async (resolve, reject) => {
        await grecaptcha.ready(() => {
          grecaptcha.execute('6Ld1EG0pAAAAACnxwWhrtmeJ15ZPF2v8PzbbTwaY', { action: 'submit' }).then(async (token) => {

            const response = await axios({
              method: 'post',
              url: '/send.php',
              data: { token: token, message: message, ...data },
              headers: {
                'Content-Type': `multipart/form-data;`,
              }
            });

            commit('setSubmitState', response.data);
            resolve(response.data);

          }).catch((error) => {
            reject(error);
          });
        });
      });

    }
  }
})
